<template>
  <popup-right
    title="Paket Ayarları"
    :isPopupVisible="isPopupVisible"
    @close="setDefaultValues"
  >
    <div
      class="package-settings"
      :class="
        $route.query.isRecommended === undefined &&
        (currentTab == 'Algo' || currentTab == 'Research')
          ? 'package_sizes'
          : ''
      "
    >
      <div class="package-settings__top m-flex m-items-center">
        <div class="package-settings__image">
          <img
            v-if="dataItem && dataItem.imageUrl"
            alt="product image"
            :src="dataItem.imageUrl"
          />
          <base-icon v-else name="no-image" />
        </div>
        <div class="package-settings__info">
          <h3>{{ dataItem.name }}</h3>

          <p class="package-settings__info-platform">
            <span>{{ dataItem.subtitle }}</span>
          </p>
        </div>
      </div>
      <div class="terminal-area" v-if="currentTab == 'Algo'">
        <div v-if="!isTerminal">
          <p class="text">
            Sistemde terminaliniz bulunmamaktadır. Lütfen öncelikle terminal
            alınız ya da Bireysel Ekranınıza
            <span v-if="dataItem.name">{{ dataItem.name }}</span>
            <span v-if="dataItem.platform && dataItem.platform.name"
              >- {{ dataItem.platform.name }}</span
            >
            <span v-else-if="dataItem.algorithm && dataItem.algorithm.name"
              >- {{ dataItem.algorithm.name }}</span
            >
            <span v-else-if="dataItem.application && dataItem.application.name"
              >- {{ dataItem.application.name }}</span
            >
            tanımlamak için kullanıcı adınızı aşağıdaki ilgili alana giriniz.
          </p>
          <base-input
            inputType="text"
            id="terminal"
            placeholder="Bireysel Kullanıcı Adı"
            :noSpace="true"
            v-model="terminalNumber"
          />
        </div>
      </div>
      <div class="warning-area" v-if="!showSections">
        <h5>Uyarı</h5>
        <div class="row-area">
          <p class="row">
            <span class="icon-area">
              <base-icon name="info" class="icon"></base-icon>
            </span>
            <span class="text" v-if="isCancelled">
              İptal ettiğiniz paketiniz bulunmaktadır. Onayladığınız takdirde
              mevcut paketinizdeki tüm lisanslar otomatik olarak aktif
              edilecektir. Lisans ekleme/çıkarma işlemlerini paketiniz aktif
              olduktan sonra düzenleme ekranından yapabilirsiniz.
            </span>
            <span class="text" v-else>
              Paket yükseltme işlemi yapmaktasınız. Mevcut paketinizdeki tüm
              lisanslar otomatik olarak yükseltilecektir. Lisans Ekleme/Çıkarma
              işlemlerini paketi aldıktan sonra yapabilirsiniz.
            </span>
          </p>
        </div>
      </div>
      <div
        class="warning-area"
        v-if="currentTab == 'Algo' && algoDetail.ruleMessage"
      >
        <h5>Uyarılar</h5>
        <div class="row-area">
          <p
            class="row"
            :key="message.id"
            v-for="message in algoDetail.ruleMessage"
          >
            <span class="icon-area">
              <base-icon name="info" class="icon"></base-icon>
            </span>
            <span class="text">{{ message }}</span>
          </p>
        </div>
      </div>
      <div class="faq-area" v-if="currentTab == 'Algo' && algoDetail.faqs">
        <h5>Sıkça Sorulan Sorular</h5>
        <faq :data="algoDetail.faqs"></faq>
      </div>
      <div
        class="warning-area"
        v-if="currentTab == 'Research' && researchDetail.ruleMessage"
      >
        <h5>Uyarılar</h5>
        <div class="row-area">
           <p class="row" v-if="(researchDetail.applicationId == 4) && (researchDetail.researchId == 13 || researchDetail.researchId == 9)">
            <span class="icon-area">
              <base-icon name="info" class="icon"></base-icon>
            </span>
            <span class="text">Matriks Mobil IQ Ürününüze bağlanır.</span>
           </p>
          <p
            v-else
            class="row"
            :key="message.id"
            v-for="message in researchDetail.ruleMessage"
          >
            <span class="icon-area">
              <base-icon name="info" class="icon"></base-icon>
            </span>
            <span class="text">{{ message }}</span>
          </p>
        </div>
      </div>
      <div
        class="package-settings__lisans"
        v-if="currentTab != 'Algo' && currentTab != 'Research'"
        v-show="showSections"
      >
        <div class="package-settings__lisans__information">
          <h5 id="lisans">Lisans Bilgileri</h5>
          <div class="market-table">
            <table class="table" aria-describedby="lisans">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="text-left">Piyasa</th>
                  <th scope="col" class="text-left">Derinlik</th>
                  <th scope="col" class="text-left">Aracı Kurum Dağılımı</th>
                  <th scope="col" class="text-left">Başlangıç Zamanı</th>
                </tr>
              </thead>
              <tbody>
                <package-setting-create-type
                  :key="item.id"
                  v-for="item in marketInfo"
                  :item="item"
                  :dataItem="dataItem"
                  :platformInfo="platformInfo"
                  :selectData="selectData"
                  :isResponsive="false"
                  :overallLimit="overallLimit"
                  @update="changeSelected"
                  @showSpesificWarning="checkSpesificWarning"
                />
              </tbody>
            </table>
          </div>
          <div class="market-table-responsive">
            <package-setting-create-type
              :key="item.id"
              v-for="item in marketInfo"
              :item="item"
              :dataItem="dataItem"
              :platformInfo="platformInfo"
              :selectData="selectData"
              :isResponsive="true"
              :overallLimit="overallLimit"
              @update="changeSelected"
              @showSpesificWarning="checkSpesificWarning"
            />
          </div>
          <div class="info-container" v-if="warningMessage">
            <info-area :infoText="infoText[1]" :typeWarning="true"></info-area>
          </div>
        </div>

        <div class="accordion-container">
          <div
            v-if="
              research.length > 0 &&
              research[0].details &&
              research[0].details.length > 0 &&
              showResearch.length > 0
            "
          >
            <accordion-research id="accordion-research" :content="research" />
          </div>
          <div
            v-if="
              foreign.length > 0 &&
              foreign[0].details &&
              foreign[0].details.length > 0 &&
              showForeign.length > 0
            "
          >
            <accordion-foreign id="accordion-foreign" :content="foreign" />
          </div>
          <div
            v-if="
              algoServer.length > 0 &&
              algoServer[0].details &&
              algoServer[0].details.length > 0 &&
              showAlgos.length > 0 &&
              Products.name.MatriksIQ == dataItem.applicationId
            "
          >
            <Maccordion-algo-server
              id="m-accordion-algo-server"
              :content.sync="algoServer"
              @changeTriggered="setPropsForAlgoServer($event)"
            />
          </div>
          <div
            v-else-if="
              algoServer.length > 0 &&
              algoServer[0].details &&
              algoServer[0].details.length > 0 &&
              showAlgos.length > 0 &&
              Products.name.MatriksIQ != dataItem.applicationId
            "
          >
            <accordion-algo-server
              id="accordion-algo-server"
              :content.sync="algoServer"
              @changeTriggered="setPropsForAlgoServer($event)"
            />
          </div>
        </div>
      </div>
      <div class="warning-area" v-if="this.isRuleMessageWarning">
        <h5>Uyarılar</h5>
        <div class="row-area">
          <p class="row">
            <span class="icon-area">
              <base-icon name="info" class="icon"></base-icon>
            </span>
            <span class="text">{{ this.itemRuleMessage }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="package-settings__bottom m-flex m-items-center">
      <div class="package-settings__bottom-right">
        <p>
          <span class="m-text-grayscale-80">BES / Yatırım Fonu:</span>
          {{
            this.dataItem.algorithm?.id === this.IDEAL_ROBOT && !isTerminal ||
            this.dataItem.algorithm?.id === this.MATRIKS_OTOALSAT_ALGOID && !isTerminal
              ? 0
              : calculateTotalFundRate
          }}
          TL
        </p>
        <p>
          <span class="m-text-grayscale-80">Komisyon:</span>
          {{
            this.dataItem.algorithm?.id === this.IDEAL_ROBOT && !isTerminal ||
            this.dataItem.algorithm?.id === this.MATRIKS_OTOALSAT_ALGOID && !isTerminal
              ? 0
              : calculateTotalComissionRate
          }}
          TL
        </p>
      </div>
      <div
        class="package-settings__bottom-left"
        :class="
          $route.query.isRecommended === undefined &&
          (currentTab == 'Algo' || currentTab == 'Research')
            ? 'package_sizes'
            : ''
        "
      >
        <div class="package-settings__price m-flex">
          <span>Toplam Tutar:</span>
          <h2>
            {{
              this.dataItem.algorithm?.id === this.IDEAL_ROBOT && !isTerminal ||
              this.dataItem.algorithm?.id === this.MATRIKS_OTOALSAT_ALGOID && !isTerminal
                ? 0
                : formatPrice(calculateTotalPrice)
            }}
            TL
          </h2>
          <h2
            v-if="
              foreign.length > 0 &&
              foreign[0].details &&
              foreign[0].details.length > 0 &&
              this.foraignDollarTotal()
            "
          >
            {{
              this.dataItem.algorithm?.id === this.IDEAL_ROBOT && !isTerminal ||
              this.dataItem.algorithm?.id === this.MATRIKS_OTOALSAT_ALGOID && !isTerminal
                ? 0
                : calculateTotalDollarForeignPrice
            }}
          </h2>
          <h2
            v-if="
              foreign.length > 0 &&
              foreign[0].details &&
              foreign[0].details.length > 0 &&
              this.foraignEuroTotal()
            "
          >
            {{
              this.dataItem.algorithm?.id === this.IDEAL_ROBOT && !isTerminal ||
              this.dataItem.algorithm?.id === this.MATRIKS_OTOALSAT_ALGOID && !isTerminal
                ? 0
                : calculateTotalEuroForeignPrice
            }}
          </h2>
        </div>
        <div
          class="package-settings__bottom-action m-flex m-items-center"
          :class="
            currentTab == 'Algo' || currentTab == 'Research'
              ? 'package_sizes'
              : ''
          "
        >
          <base-select
            fieldLabel="Başlangıç Zamanı"
            :options="startDate"
            id="startTime"
            @change="changeStartDate"
            :selectedId="startDateSelection"
            placeholder="Seçiniz"
            v-if="currentTab == 'Algo' || currentTab == 'Research'"
            :class="
              currentTab == 'Algo' || currentTab == 'Research'
                ? 'algoResearchStyles'
                : ''
            "
            class="start-date-select"
          />
          <base-button
            id="create-submit-btn"
            @click="submitShow"
            :class="{ 'button-disabled': isButtonClicked }"
            >Onayla</base-button
          >
        </div>
      </div>
    </div>
    <div class="info-container">
      <info-area :infoText="infoText[0]" :typeWarning="true"></info-area>
    </div>
    <div
      class="modal-area"
      name="operation-warning"
      id="operation-warning"
      v-if="isOperationWarningVal === true"
    >
      <div class="modal-area__inner">
        <div class="modal-heading">
          <div class="modal-title">
            <h5>Bu işlemi onaylıyor musunuz?</h5>
          </div>
          <a @click="modalNo()" id="close-operation-warning">
            <base-icon class="close" name="close"></base-icon>
          </a>
        </div>
        <div class="modal-body">
          <span>{{ operationMessage }}</span>
        </div>
        <div class="modal-bottom">
          <base-button class="no" @click="modalNo()">Hayır</base-button>
          <base-button class="hide" @click="modalHide()">Evet</base-button>
        </div>
      </div>
    </div>
  </popup-right>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import PackageSettingCreateType from "./PackageSettingCreateType.vue";
import mixins from "../../mixins";
import {
  PopupRight,
  BaseButton,
  AccordionResearch,
  AccordionForeign,
  AccordionAlgoServer,
  BaseSelect,
  BaseInput,
  BaseIcon,
} from "@/components";
import MaccordionAlgoServer from "../base/MaccordionAlgoServer.vue";
import InfoArea from "../base/InfoArea.vue";
import Faq from "../base/Faq.vue";
import { statuses } from "../../constants";
import { getItem } from "../../utils/tokenTools";
export default {
  name: "PackageSettingCreate",
  mixins: [mixins],
  components: {
    BaseButton,
    PopupRight,
    PackageSettingCreateType,
    AccordionResearch,
    AccordionForeign,
    AccordionAlgoServer,
    MaccordionAlgoServer,
    BaseInput,
    BaseSelect,
    BaseIcon,
    InfoArea,
    Faq,
  },
  props: {
    dataItem: Object,
    platformInfo: Object,
    marketInfo: Array,
    isPopupVisible: Boolean,
    currentTab: String,
    isTerminal: Boolean,
    algoDetail: Object,
    isOperationWarning: Boolean,
    operationMessage: String,
    researchDetail: Object,
    isRuleMessageWarning: Boolean,
    mutableItemRuleMessage: String,
    isUpgraded: Boolean,
    isCancelled: Boolean,
    startDates: Number,
  },
  data() {
    return {
      bottomFund: 0,
      bottomCommission: 0,
      totalPrice: 0,
      startDateSelection: -1,
      selectData: [],
      research: [],
      foreign: [],
      algoServer: [],
      researchData: [],
      foreignData: [],
      algoServerData: [],
      updatedList: [],
      args: {},
      argsAlgo: {},
      argsResearch: {},
      terminalNumber: null,
      isOperationWarningVal: this.isOperationWarning,
      isButtonClicked: false,
      itemRuleMessage: this.mutableItemRuleMessage,
      warningMessage: false,
      recommendedPackageChecker: false,
      IDEAL_ROBOT: 7,
      MATRIKS_OTOALSAT_ALGOID: 4,
      infoText: [
        "Komisyon ya da BES/FON büyüklük şartı sağlanması halinde, ilgili ay için belirtilen veri lisans ücreti alınmayacaktır.",
        "Karma Lisans paketinde derinlik bilgisi bulunmamaktadır.",
      ],
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
      overallLimit: 0,
      cusId: null,
      showSections: true,
      esube: getItem("esube"),
    };
  },
  mounted() {
    const cusId =
      this.$route.params.customerId !== undefined
        ? this.$route.params.customerId
        : null;
    if (this.currentTab != "Algo" && this.currentTab != "Research") {
      this.getResearch([this.dataItem?.applicationId, cusId]).then((res) => {
        let details = {};
        details = res.data;

        if (
          this.dataItem.platform.id === this.Products.type.Desktop &&
          this.dataItem.applicationId === this.Products.name.Matriks
        ) {
          details = details.filter((o) => o.name === "Stockkeys");
        }

        if (
          this.dataItem.platform.id === this.Products.type.Mobile &&
          (this.dataItem.applicationId === this.Products.name.Matriks ||
            this.dataItem.applicationId === this.Products.name.MatriksIQ)
        ) {
          details = details.filter((o) => o.name === "Osmanlı Pro");
        }

        this.research.push({
          id: 1,
          active: false,
          title: "Araştırma ve Diğer Uygulamalar",
          details,
        });
      });
      this.getForeign([
        this.dataItem?.applicationId,
        this.dataItem?.platform?.id,
        cusId,
      ]).then((res) => {
        let details = {};
        details = res.data;
        this.foreign.push({
          id: 2,
          active: false,
          title: "Yabancı Endeksler",
          details,
        });
      });
      this.getAlgoServer([this.dataItem?.applicationId, cusId]).then((res) => {
        let details = {};
        details = res.data;

        // Terminal ürünü her durumda listeden kaldırılmalı.
        const terminalAlgoName = "MATRİKS - Oto Al-Sat - Terminal";
        const idealTerminalName = "İDEAL - Robot Yetkisi - Terminal";

        details = (details || []).filter(
          (element) => (element?.name !== terminalAlgoName && element?.name !== idealTerminalName)
        );

        details.forEach((element) => {
          element.isChecked = false;
          if (element.algorithmId == 80) {
            element.isDisable = true;
            element.showNextMonth = false;
          }
        });
        this.algoServer.push({
          id: 3,
          active: false,
          title: "Algoritmalar",
          details,
        });
      });
    }
    this.setSelectedResearch([]);
    this.setSelectedForeign([]);
    this.setSelectedAlgoServer([]);
    this.$nextTick(() => {
      if (this.setSelectboxList == 0 || this.setSelectboxList == 1) {
        const returnAsArrray = this.startDate.filter((option) => {
          if (option.code == this.setSelectboxList) {
            return option;
          }
        });
        this.startDate = returnAsArrray;
        this.changeStartDate(returnAsArrray[0]);
      }
      this.getOverallLimitOnLoad();
    });
  },
  computed: {
    ...mapGetters([
      "customer",
      "getSelectedResearchInfo",
      "getSelectedForeignInfo",
      "getSelectedAlgoServerInfo",
      "allPackages",
    ]),
    calculateTotalFundRate() {
      let result;
      if (this.currentTab === "Research") {
        result = this.formatPrice(this.researchFund());
      } else if (this.currentTab === "Algo") {
        result = this.formatPrice(this.algoServerFund());
      } else {
        result = this.formatPrice(
          this.bottomFund +
            this.foreignFund() +
            this.researchFund() +
            this.algoServerFund()
        );
      }
      return result;
    },
    calculateTotalComissionRate() {
      let result;
      if (this.currentTab === "Research" && this.currentTab) {
        result = this.formatPrice(this.researchCommission());
      } else if (this.currentTab === "Algo") {
        result = this.formatPrice(this.algoServerCommission());
      } else {
        result = this.formatPrice(
          this.bottomCommission +
            this.foreignCommission() +
            this.researchCommission() +
            this.algoServerCommission()
        );
      }
      return result;
    },
    calculateTotalPrice() {
      return (
        this.dataItem.price +
        this.totalPrice +
        this.researchTotal() +
        this.foraignTurkishLiraTotal() +
        this.algoServerTotal()
      );
    },
    calculateTotalDollarForeignPrice() {
      return (
        " + " + this.formatPriceDollar(this.foraignDollarTotal()) + " USD "
      );
    },
    calculateTotalEuroForeignPrice() {
      return " + " + this.formatPriceEuro(this.foraignEuroTotal()) + " EUR";
    },
    calculateTotalTurkishLiraForeignPrice() {
      return " + " + this.formatPrice(this.foraignTurkishLiraTotal()) + "TL";
    },
    setSelectboxList() {
      return this.startDates;
    },
    showAlgos() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Foreks)
      );
    },
    showResearch() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Ideal)
      );
    },
    showForeign() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Foreks)
      );
    },
  },
  methods: {
    ...mapMutations([
      "setSelectedResearch",
      "setSelectedForeign",
      "setSelectedAlgoServer",
      "setAlgoServer",
      "setUpgradeHappend",
    ]),
    ...mapActions([
      "createPackage",
      "getResearch",
      "getForeign",
      "getAlgoServer",
      "algorithmCreate",
      "researchCreate",
      "createRecommendationPackage",
      "monthlyGetOverallLimit",
    ]),
    setPropsForAlgoServer(checkedDataListFromChildren) {
      let data = [checkedDataListFromChildren];
      let updatedDetails = [...data];
      const item = checkedDataListFromChildren;
      this.algoServer[0].details.forEach((detail) => {
        if (!data.some((item) => item.algorithmId === detail.algorithmId)) {
          updatedDetails.push(detail);
        }
      });

      const algoId5 = updatedDetails.find((item) => item.algorithmId === 5);
      const grid = updatedDetails.find((item) => item.algorithmId === 80);
      const gridIndex = updatedDetails.findIndex(
        (item) => item.algorithmId === 80
      );

      if (!algoId5.isChecked) {
        updatedDetails[gridIndex].isDisable = true;

        if (grid.isChecked) {
          updatedDetails[gridIndex].isChecked = false;
        }
      } else {
        if (algoId5.dateSelection == 1) {
          updatedDetails[gridIndex].dateSelection = 1;
          updatedDetails[gridIndex].showNextMonth = true;
        } else {
          updatedDetails[gridIndex].showNextMonth = false;
          if (item.algorithmId == 80) {
            updatedDetails[gridIndex].dateSelection = item.dateSelection;
          } else {
            updatedDetails[gridIndex].dateSelection = -1;
          }
        }
        if (grid) {
          updatedDetails[gridIndex].isDisable = algoId5.isChecked
            ? false
            : true;
        }
      }

      const index = this.updatedList.findIndex(
        (existingItem) => existingItem.id === item.id
      );

      if (item.isChecked) {
        if (index === -1) {
          this.updatedList.push(item);
        } else {
          this.updatedList[index] = item;
        }
      } else {
        if (index !== -1) {
          this.updatedList.splice(index, 1);
          const grid = this.updatedList.findIndex(
            (item) => item.algorithmId === 80
          );
          if (grid != -1 && item.algorithmId != 6) {
            this.updatedList.splice(grid, 1);
          }
        }
      }
      const list = [6, 5, 80];
      updatedDetails.sort(
        (a, b) => list.indexOf(a.algorithmId) - list.indexOf(b.algorithmId)
      );

      this.algoServer[0].details = updatedDetails;
      this.setSelectedAlgoServer(this.updatedList);
    },
    modalNo() {
      this.setDefaultValues();
    },
    modalHide() {
      document.getElementById("operation-warning").remove();
    },
    checkSpesificWarning(param) {
      this.warningMessage = param;
    },
    setDefaultValues() {
      this.bottomCommission = 0;
      this.totalPrice = 0;
      this.bottomFund = 0;
      this.showSections = false;
      this.$emit("close");
    },
    getOverallLimitOnLoad() {
      this.monthlyGetOverallLimit().then((response) => {
        if (response.status === 200) {
          this.overallLimit = response.data.overallLimit;
        }
      });
    },
    researchFund() {
      if (this.currentTab == "Research") {
        return this.dataItem?.fundAmount || 0;
      } else {
        return this.getSelectedResearchInfo.reduce((totald, item) => {
          return (item?.fundAmount || 0) + totald;
        }, 0);
      }
    },
    foreignFund() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        return (item?.fundAmount || 0) + totald;
      }, 0);
    },
    algoServerFund() {
      if (this.currentTab == "Algo") {
        return this.dataItem?.fundAmount || 0;
      } else {
        return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
          return (item?.fundAmount || 0) + totald;
        }, 0);
      }
    },
    // Commission calc
    researchCommission() {
      if (this.currentTab == "Research") {
        return this.dataItem?.commissionAmount || 0;
      } else {
        return this.getSelectedResearchInfo.reduce((totald, item) => {
          return (item?.commissionAmount || 0) + totald;
        }, 0);
      }
    },
    foreignCommission() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        return (item?.commissionAmount || 0) + totald;
      }, 0);
    },
    algoServerCommission() {
      if (this.currentTab == "Algo") {
        return this.dataItem?.commissionAmount || 0;
      } else {
        return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
          return (item?.commissionAmount || 0) + totald;
        }, 0);
      }
    },
    // Total calc
    researchTotal() {
      return this.getSelectedResearchInfo.reduce((totald, item) => {
        return (item?.price || 0) + totald;
      }, 0);
    },
    foraignTurkishLiraTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "₺") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    foraignDollarTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "$") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    foraignEuroTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "€") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    algoServerTotal() {
      return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
        return (item?.price || 0) + totald;
      }, 0);
    },
    changeSelected(data) {
      this.selectData = data;
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
    },
    errorMessage(res) {
      if (res.statusCode === statuses.INTERNAL_SERVER_ERROR) {
        this.$toast.error(res.message);
      } else if (res.errorCode === statuses.NOT_ACCEPTABLE) {
        this.$toast.error(res.result.data[0].errors[0]);
      } else {
        this.$toast.error("Beklenmedik bir hata oluştu");
      }
      this.isButtonClicked = false;
    },
    getCustomerNumber() {
      return this.customer.customerNo
        ? this.customer.customerNo
        : this.$route.query.c;
    },
    submitShow() {
      this.isButtonClicked = true;
      this.cusId = this.$route.query.c;
      const packageData = this.mapPackageData(this.selectData);

      const getEveryDateSelection = packageData.filter(
        (o) => o.dateSelection == -1
      );
      const getResearchDateSelection = this.getSelectedResearchInfo.filter(
        (o) => o.dateSelection === -1
      );

      const getForeignDateSelection = this.getSelectedForeignInfo.filter(
        (o) => o.dateSelection === -1
      );

      const getSelectedAlgoServerInfo = this.getSelectedAlgoServerInfo.filter(
        (o) => o.dateSelection === -1
      );

      this.researchData = this.mapArrays(
        this.getSelectedResearchInfo,
        "researchId",
        "dateSelection"
      );

      this.foreignData = this.mapArrays(
        this.getSelectedForeignInfo,
        "foreignIndiceId",
        "dateSelection"
      );

      this.algoServerData = this.mapArrays(
        this.getSelectedAlgoServerInfo,
        "algorithmAndServerId",
        "dateSelection"
      );

      if (
        (this.showSections &&
          (getEveryDateSelection.length > 0 ||
            getResearchDateSelection.length > 0 ||
            getForeignDateSelection.length > 0 ||
            getSelectedAlgoServerInfo.length > 0)) ||
        (this.dataItem.platform == undefined && this.startDateSelection == -1)
      ) {
        this.$toast.error("Başlangıç zamanı seçiniz.");
        this.isButtonClicked = false;
        return;
      }

      this.argsAlgo = {
        customerId: this.customer.id,
        dateSelection: this.startDateSelection,
        applicationId: this.dataItem?.applicationId || null,
        algorithmId: this.dataItem.id,
        terminalNumber: this.isTerminal ? "" : this.terminalNumber,
        cusId: Number(this.customer.id),
      };

      this.argsResearch = {
        customerId: this.customer.id,
        dateSelection: this.startDateSelection,
        applicationId: this.dataItem?.applicationId || null,
        researchId: this.dataItem.id,
        cusId: Number(this.customer.id),
      };

      let recommendedPackageArgs = {
        recommendationPackageId: this.dataItem.id,
        /*recommendationPackageNo: this.dataItem.recommendationPackageNo,*/
        applicationId: this.dataItem?.applicationId || null,
        platformId: this.dataItem?.platform?.id || null,
        features: packageData,
        research: this.researchData,
        foreignIndice: this.foreignData,
        algorithmAndServer: this.algoServerData,
      };
      if (this.$route.query.isRecommended == "1") {
        if (this.recommendedPackageChecker) {
          this.$toast.error("Lisans seçiniz");
          this.isButtonClicked = false;
          return;
        } else {
          if (this.dataItem.platform == undefined) {
            recommendedPackageArgs = {
              RecommendedPackageId: this.dataItem.id,
              research: [
                {
                  researchId: this.dataItem.id,
                  dateSelection: this.startDateSelection,
                },
              ],
            };
          }
          this.createRecommendationPackage(recommendedPackageArgs).then(() => {
            this.$router.push({ name: "RecommendedPackages" });
          });
        }
      } else if (
        this.isRecommendedUndefined &&
        this.currentTab !== "Algo" &&
        this.currentTab !== "Research"
      ) {
        this.pureCreate(packageData);
      } else if (this.isRecommendedUndefined && this.currentTab === "Algo") {
        this.createAlgo(this.argsAlgo);
      } else if (
        this.isRecommendedUndefined &&
        this.currentTab === "Research"
      ) {
        this.createResearch(this.argsResearch);
      }
    },
    mapArrays(arrayList, keyItem, dateSelection) {
      const mappedArray = arrayList.map((key) => {
        return {
          [keyItem]: key.id || null,
          [dateSelection]: key.dateSelection || 0,
        };
      });
      return mappedArray;
    },
    mapPackageData(packageData) {
      const resultData = packageData.map((item) => {
        return {
          marketId: item?.marketFeature?.id || null,
          perspectiveId: item?.perspectiveFeature?.id || null,
          vendorId:
            item?.vendorFeature?.id === undefined ||
            item?.vendorFeature?.id === null
              ? null
              : item?.vendorFeature?.id,
          dateSelection: item.dateSelection,
        };
      });
      return resultData;
    },
    isRecommendedUndefined() {
      return this.$route.query.isRecommended === undefined;
    },
    pureCreate(packageData) {
      this.args = {
        customerId: this.customer.id,
        purchaseNumber: "",
        applicationId: this.dataItem?.applicationId || null,
        applicationFeatureId: this.dataItem.id,
        platformFeatureId: this.dataItem.id,
        platformId: this.dataItem?.platform?.id || null,
        features: packageData,
        research: this.researchData,
        foreignIndice: this.foreignData,
        algorithmAndServer: this.algoServerData,
        cusId: Number(this.cusId),
      };
      this.createPackage(this.args).then((res) => {
        if (res.error) {
          this.errorMessage(res);
        } else {
          if (res.isUpgradedPurchase) {
            this.setUpgradeHappend(true);
          }
          this.$router.push({
            name: "Checkout",
            params: {
              packageNumber: res.purchaseId,
              isUpgradedPurchase: res.isUpgradedPurchase,
              customerNumber: this.customer.customerNo
                ? this.customer.customerNo
                : this.$route.query.c,
            },
            query: { c: this.$route.query.c },
          });
          this.setSelectedResearch([]);
          this.setSelectedForeign([]);
          this.setSelectedAlgoServer([]);
        }
      });
    },
    createAlgo() {
      if (this.startDateSelection == -1) {
        this.$toast.error("Başlangıç zamanı seçiniz.");
        this.isButtonClicked = false;
        return;
      }
      if (this.isTerminal === false && this.terminalNumber === null) {
        this.$toast.error("Terminal Numarası Giriniz.");
        this.isButtonClicked = false;
        return;
      }
      this.algorithmCreate(this.argsAlgo).then((res) => {
        if (res.error) {
          this.$toast.error(res.message);
          this.isButtonClicked = false;
        } else {
          if (!res.isExternalTerminal) {
            this.$router.push({
              name: "Checkout",
              params: {
                packageNumber: res.purchaseId,
                isUpgradedPurchase: res.purchaseNo,
                customerNumber: this.customer.customerNo
                  ? this.customer.customerNo
                  : this.$route.query.c,
              },
              query: { c: this.$route.query.c },
            });
          } else {
            this.$toast.success(
              "Paketiniz en kısa sürede tanımlanacaktır. Kullanıcı adı ve şifre bilgisi gerektiren paketlerde bu bilgiler e-posta ile gönderilmektedir. Lütfen e-posta adresinizde spam klasörünü kontrol ediniz."
            );
            this.$router.push({
              name: "CustomerDetail",
              params: {
                customerId: this.$route.query.c,
                customerNumber: this.$route.params.customerNumber,
              },
              query: { c: this.$route.query.c },
            });
          }
        }
      });
    },
    createResearch() {
      if (this.validateStartDate()) return;
      if (this.validateTerminalNumber()) return;

      this.researchCreate(this.argsResearch).then((res) => {
        if (res.error) {
          this.errorMessage(res);
          this.isButtonClicked = false;
        } else {
          this.navigateToDestination(res);
        }
      });
    },
    calculatePrice(items) {
      this.bottomFund = items.reduce((totald, item) => {
        return (
          (item?.marketFeature?.fundAmount || 0) +
          (item?.perspectiveFeature?.fundAmount || 0) +
          (item?.vendorFeature?.fundAmount || 0) +
          totald
        );
      }, this.dataItem.fundAmount);
      this.bottomCommission = items.reduce((totald, item) => {
        return (
          (item?.marketFeature?.commissionAmount || 0) +
          (item?.perspectiveFeature?.commissionAmount || 0) +
          (item?.vendorFeature?.commissionAmount || 0) +
          totald
        );
      }, this.dataItem.commissionAmount);
      // eslint-disable-next-line no-unused-vars
      const totalPrice = items.reduce((totald, item) => {
        return (
          /*(item?.marketFeature?.price || 0) +
          (item?.platformFeature?.price || 0)*/ +(
            item?.perspectiveFeature?.price || 0
          ) +
          (item?.vendorFeature?.price || 0) +
          totald
        );
      }, 0);
      this.totalPrice = totalPrice;
    },
    navigateToDestination(res) {
      if (!res.isExternalTerminal) {
        this.$router.push({
          name: "Checkout",
          params: {
            packageNumber: res.purchaseId,
            isUpgradedPurchase: res.purchaseNo,
            customerNumber: this.getCustomerNumber(),
          },
          query: { c: this.$route.query.c },
        });
      } else {
        this.$toast.success(
          "Paketiniz en kısa sürede tanımlanacaktır. Kullanıcı adı ve şifre bilgisi gerektiren paketlerde bu bilgiler e-posta ile gönderilmektedir. Lütfen e-posta adresinizde spam klasörünü kontrol ediniz."
        );
        this.$router.push({
          name: "CustomerDetail",
          params: {
            customerId: this.$route.query.c,
            customerNumber: this.getCustomerNumber(),
          },
          query: { c: this.$route.query.c },
        });
      }
    },
    validateTerminalNumber() {
      if (!this.isTerminal && this.terminalNumber === null) {
        this.$toast.error("Terminal Numarası Giriniz.");
        this.isButtonClicked = false;
        return true;
      }
      return false;
    },
    validateStartDate() {
      if (this.startDateSelection == -1) {
        this.$toast.error("Başlangıç zamanı seçiniz.");
        this.isButtonClicked = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    selectData: {
      handler(newVal) {
        this.calculatePrice(newVal);
        if (
          this.$route.query.isRecommended != undefined &&
          newVal.length == 0
        ) {
          if (this.dataItem.applicationId == 0) {
            this.recommendedPackageChecker = false;
          } else {
            this.recommendedPackageChecker = true;
          }
        } else if (
          this.$route.query.isRecommended != undefined &&
          newVal.length != 0
        ) {
          this.recommendedPackageChecker = false;
        }
      },
      deep: true,
      immediate: true,
    },
    isUpgraded: {
      handler(val) {
        if (val) {
          this.showSections = false;
        } else {
          this.showSections = true;
        }
      },
      deep: true,
      immediate: true,
    },
    startDates: {
      handler(val) {
        if (val == 0 || val == 1) {
          const returnAsArrray = this.startDate.filter(
            (option) => option.code == val
          );
          this.startDate = returnAsArrray;
          this.changeStartDate(returnAsArrray[0]);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.osm-vd {
  .veri-dagitim-selectbox.v-select {
    overflow-y: scroll;
  }
  .m-flex {
    display: flex;
  }
  .m-items-center {
    align-items: center;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .text-center {
    text-align: center;
  }

  .modal-area {
    position: fixed;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.17);

    &__inner {
      width: 580px;
      background-color: var(--grayscale-0);
      .modal-heading {
        height: 40px;
        border-bottom: 1px solid var(--grayscale-30);
        display: flex;
        align-items: center;
        padding: 15px;
        justify-content: space-between;
        .close {
          margin: 5px;
          cursor: pointer;
        }
      }
      .modal-body {
        padding: 15px;
        span {
          font-size: 14px;
          line-height: 24px;

          a:link,
          a:visited {
            color: var(--body-text);
          }
        }
      }
      .modal-bottom {
        margin-top: 1em;
        border-top: 1px solid var(--grayscale-30);
        display: flex;
        justify-content: flex-end;
        padding: 15px 30px;
        .base-button {
          background-color: var(--color-warning);
          color: var(--grayscale-0);
          width: 180px;
          font-size: 15px;
          margin-left: 10px;
          &.hide {
            background-color: var(--color-primary-default);
          }
        }
      }
    }
  }

  .package-settings {
    overflow: auto;
    @media (min-width: 640px) {
      height: calc(100vh - 250px);
    }

    &__info {
      h3 {
        font-size: 16px;
      }
      span {
        font-size: 14px;
      }
    }
    &__info-platform {
      font-size: 16px;
    }
    &__info_price {
      font-size: 29px;
      font-weight: bold;
      margin-top: 12px;
    }
    &__info_bes,
    &__info_bes span {
      font-size: 14px;
    }
    &__image img {
      margin-right: 20px;
      width: 80px;
      object-fit: contain;
      @media (max-width: 768px) {
        margin-right: 0px;
      }
    }
    &__top {
      margin-bottom: 30px;
      gap: 10px;
      @media (max-width: 768px) {
        margin-bottom: 16px;
      }
    }
    &__lisans {
      overflow-y: auto;
      &__information {
        padding: 20px;
        background: var(--grayscale-0);
        margin-bottom: 20px;
        @media (max-width: 768px) {
          border-radius: 4px;
          padding: 12px;
        }

        h5 {
          font-size: 14px;
          font-weight: 600;
          @media (max-width: 768px) {
            border-bottom: 1px solid var(--color-primary-tint-second);
            margin: auto -12px 16px -12px;
            padding: 0px 12px 13px 12px;
          }
        }
        .table {
          margin-bottom: 0px !important;
        }
      }
      @media (max-width: 898px) {
        overflow: auto;
      }
      .table {
        border-collapse: collapse;
        text-indent: 0;
        min-width: 100%;
        border-radius: var(--radius-second) !important;
        overflow: auto;
        border: solid 1px var(--color-primary-tint-second);
        background-color: #fff;
        margin: 20px 0px;
        overflow-y: visible !important;

        ::v-deep th {
          background: var(--grayscale-160);
          height: 40px;
          font-weight: 600 !important;
        }

        ::v-deep th,
        ::v-deep td {
          font-size: 12px;
          vertical-align: middle;
          border-top: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          font-weight: 500;
          .option {
            .veri-dagitim-selectbox.v-select {
              border: 1px solid transparent;
              width: 100%;

              .vs {
                &__dropdown-toggle {
                  padding: 0px;
                  border: 0px !important;
                  position: relative;

                  &:focus-visible {
                    outline: none !important;
                  }

                  svg {
                    display: block !important;
                  }
                }

                &__selected {
                  padding: 0;
                  margin: 0;

                  &-options {
                    padding: 0px !important;
                    position: relative;
                    flex-basis: auto !important;
                    flex-grow: 0 !important;
                  }
                }

                &__clear {
                  display: none !important;
                }

                &__actions {
                  padding: 0px;
                  cursor: pointer !important;
                  background: transparent !important;
                }
              }

              &__search,
              &__search:focus {
                border: none !important;
              }
            }

            .editing-view-port {
              display: none !important;
            }
          }
        }

        ::v-deep tbody {
          tr:nth-child(2n) {
            background: var(--color-primary-zebra);
          }
          tr td {
            height: 64px;
            color: var(--grayscale-200);

            &:nth-child(2) {
              width: 110px;
              .paranthesis {
                font-size: 11px;
              }
            }

            &:nth-child(3),
            &:nth-child(4) {
              min-width: 252px;
            }
          }
          tr td:first-child {
            width: 38px;
            padding: 0px;
            padding-right: 6px;
            text-align: right;
            border-left: 1px solid #e8e8e8;
          }

          td:last-child {
            width: 150px;
            padding-right: 20px;
            .veri-dagitim-selectbox.v-select {
              .vs__dropdown-toggle {
                min-width: auto;
                font-size: 14px;
              }
              .vs__search {
                display: none;
              }
            }
          }
        }
      }

      .info-option {
        display: flex;
        align-items: center;
        justify-content: left;
        svg {
          cursor: pointer;
        }
      }
      .accordion-container {
        width: 100%;
      }
      .info-container {
        margin-top: 20px;
        .infoArea {
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 640px) {
      &__bottom-right {
        text-align: left;
        margin-bottom: 0px;
      }
    }
    &__bottom {
      width: 100%;
      padding: 20px 0px 8px 0px;
      border-top: 1px solid var(--grayscale-30);
      justify-content: space-between;
      background-color: var(--grayscale-10);

      &-left {
        display: flex;
        &.package-sizes {
          flex-direction: row;
        }
      }
      @media (max-width: 640px) {
        position: relative;
        flex-flow: column;
        padding: 12px 0px;
        box-sizing: border-box;
      }
      ::v-deep .form-group {
        position: relative;
        margin-right: 16px;
        width: 100%;
      }
      ::v-deep .form-control-label {
        font-size: 12px;
        color: var(--grayscale-70);
        position: absolute;
        padding: 0 7px;
        margin-left: 10px;
        z-index: 2;
        top: -5px;
      }
    }
    &__bottom-right {
      line-height: 24px;
      @media (max-width: 640px) {
        width: 100%;
        text-align: left;
        margin-bottom: 0px;
        justify-content: flex-start;

        ::v-deep p {
          margin-bottom: 8px;
        }
      }
      ::v-deep p,
      ::v-deep span {
        font-size: 14px;
        font-weight: 600;
        color: var(--grayscale-120);
      }
      ::v-deep p {
        color: var(--color-primary-black-metallic);
      }
    }
    @media (max-width: 640px) {
      &__bottom-left {
        width: 100%;
        flex-direction: column;
      }
    }

    &__bottom-action {
      width: 216px;
      margin-left: 40px;
      @media (max-width: 640px) {
        width: 100%;
        align-items: inherit;
        flex-flow: column;
        margin-left: auto;
        .start-date-select {
          width: 100%;
          margin-bottom: 10px;
        }
      }
      &.package_sizes {
        flex-direction: row;
        gap: 5px;
        width: auto;
        margin-left: 10px;
        .start-date-select {
          margin-right: 0px;
        }
        .form-group {
          width: auto;
        }
        .base-button {
          width: 216px;
        }
        @media (max-width: 768px) {
          margin-left: 0px;
          flex-direction: column;
          .base-button {
            width: 100%;
          }
        }
      }
    }
    &__price {
      align-items: center;
      justify-content: center;
      font-weight: 600;
      @media (max-width: 640px) {
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 15px;
        width: 100%;
      }
      span {
        font-size: 14px;
        color: var(--grayscale-120);
      }
      h2 {
        font-size: 14px;
        color: var(--color-primary-black-metallic);
        margin-left: 5px;
      }
    }
    .up svg {
      color: #28a745;
    }
    .down svg {
      color: #dc3545;
    }
    .warning-area {
      margin-bottom: 2em;
      .row-area {
        border: 1px solid var(--grayscale-30);
        border-radius: var(--radius-second);
        margin-top: 1em;
        .row {
          padding: 15px;
          display: flex;
          align-items: center;
          .icon-area {
            margin-right: 10px;
          }
          &:nth-child(odd) {
            background-color: var(--grayscale-0);
          }
        }
      }
    }
    .terminal-area {
      padding: 20px 0;
      margin-bottom: 1em;
      .text {
        margin-bottom: 1em;
      }
    }
  }

  .market-table {
    width: 100%;
    display: block;
  }
  .market-table-responsive {
    width: 100%;
    display: none;
  }
  @media (max-width: 640px) {
    .info-container {
      position: relative;
      margin-top: 20px;
    }
    .market-table {
      display: none;
    }
    .market-table-responsive {
      display: block;
    }
  }
  @media (max-width: 389px) {
    .info-container {
      margin-top: 8px;
    }
  }
}
</style>
